import { Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';

import type { RumEventMap, RumViewContext, RumViewName } from './rum-events';

/**
 * Thin typed wrapper over the `datadogRum` calls ToolHive makes. Inject this from feature code —
 * action names, payloads, view names and view attributes are all checked against the catalog in
 * `rum-events.ts`, so they can't drift.
 */
@Injectable({ providedIn: 'root' })
export class RumAnalyticsService {
  trackAction<K extends keyof RumEventMap>(name: K, attributes: RumEventMap[K]): void {
    datadogRum.addAction(name, attributes);
  }

  /**
   * Replace the current view's URL-derived name with a stable route name, so views of different
   * entities on the same route group into one row instead of one per UUID.
   */
  setViewName(name: RumViewName): void {
    datadogRum.setViewName(name);
  }

  /**
   * Attach attributes to the current view, surfacing as `@view.context.*`. Enriches the view RUM
   * already emits on route change rather than adding a parallel custom-action stream.
   */
  setViewContext(context: RumViewContext): void {
    datadogRum.setViewContext(context);
  }
}
